.gridSpacing {
  margin-bottom: var(--tuna-spacing-2);
}

.playScaleButton {
  margin-left: var(--tuna-spacing-1);
}

.intervalGrid {
  margin-bottom: var(--tuna-spacing-2);
}

.intervalCell {
  padding: var(--tuna-spacing-1);
  text-align: center;
}

.chordGrid {
  margin-bottom: var(--tuna-spacing-2);
}

.chordButtonWrapper {
  display: flex;
  align-items: center;
}

.chordButton {
  min-width: 60px;
  margin: 4px;
  text-transform: none;
}

.circleOfFifthsGrid {
  justify-content: center;
  display: flex;
}

.circleOfFifthsContainer {
  width: 100%;
  height: auto;
  max-width: 40vh;
  max-height: 40vh;
  display: flex;
  aspect-ratio: 1 / 1;
}

.divider {
  margin-top: var(--tuna-spacing-2);
  margin-bottom: var(--tuna-spacing-2);
}

.selectedChordSection {
  margin-bottom: var(--tuna-spacing-2);
}

.flexCenter {
  display: flex;
  align-items: center;
}

.playChordButton {
  margin-left: var(--tuna-spacing-1);
}

.backToScaleButton {
  margin-left: var(--tuna-spacing-2);
}

.tabsSection {
  margin-bottom: var(--tuna-spacing-2);
}

.tabContent {
  margin-top: var(--tuna-spacing-2);
}
